import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { useParallax } from '../../../hooks/useParallax';

export default function AboutSection() {
  // Removed explicit generic arguments – they are inferred and can cause JSX parsing issues
  const { ref: sectionRef, isVisible } = useScrollAnimation();
  const { ref: decorRef, style: decorStyle } = useParallax({ speed: 0.2, direction: 'up' });

  return (
    <section
      id="about"
      ref={sectionRef}
      className="bg-dark py-16 sm:py-24 px-4 sm:px-8 lg:px-16 relative overflow-hidden"
    >
      {/* Parallax Decorative Elements */}
      <div ref={decorRef} style={decorStyle} className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-20 -right-20 w-80 h-80 bg-gold/5 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-20 w-96 h-96 bg-gold/3 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div
          className={`text-center mb-10 sm:mb-16 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="w-16 h-0.5 bg-gold mx-auto mb-6 sm:mb-8"></div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 sm:mb-8">
            <a href="#about">
              <strong>
                GA HR Group — это не компания. Это мой личный бренд и моя экспертиза.
              </strong>
            </a>
          </h2>
          <div className="font-body text-base sm:text-lg text-white/80 leading-relaxed max-w-3xl mx-auto px-2 space-y-6 mb-10">
            <p>
              <strong className="text-gold text-2xl sm:text-3xl lg:text-4xl">
                Горбатовская Ангелина
              </strong>
              <span className="text-white/80"> — внешний HR-стратег для собственников, которые устали от хаоса в управлении людьми.</span>
            </p>
            
            <p className="text-white/70">
              Я не веду кадровый учёт. Я строю системы, которые экономят бюджет, снижают риски и возвращают владельцу бизнеса время и спокойствие.
            </p>
            
            <p className="text-white/70">
              Никаких агентств и посредников. Только личная экспертиза и ответственность за результат.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {[
            { number: '1', text: 'Личная экспертиза, а не «менеджер на обзвоне». ' },
            { number: '2', text: 'HR как инвестиция, а не статья расходов.' },
            { number: '3', text: 'Система, которая работает без моего присутствия.' },
            { number: '4', text: 'Снижение налоговых и трудовых рисков.' },
            { number: '5', text: 'Собственник в роли стратега, а не пожарного.' },
          ].map((item, index) => (
            <div
              key={index}
              className={`bg-dark-light border border-white/10 rounded-lg p-6 sm:p-8 hover:border-gold/40 hover:-translate-y-1 transition-all duration-500 group ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: isVisible ? `${(index + 1) * 100}ms` : '0ms' }}
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-gold/10 rounded-lg group-hover:bg-gold/20 transition-colors duration-300">
                  <span className="font-heading text-lg font-bold text-gold">{item.number}</span>
                </div>
                <p className="font-body text-sm text-white/70 leading-relaxed pt-1">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
